// extracted by mini-css-extract-plugin
export default {"root":"AvcH_Q","direction-horizontal":"juDog9","directionHorizontal":"juDog9"};